import React, { useEffect, useState } from "react";
import { Form, Col, Row, Select, Button, Space, Card } from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import { useNavigate } from "react-router-dom";

function Result() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [getStudentResponse, getStudentsRequest] = useApi(
    "/admin/student/get-all",
    null,
    API_METHODS.GET
  );

  const [getResultsResponse, getResultsRequest] = useApi(
    `/admin/student/get-all-results?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const columns = [
    {
      title: "Student Name",
      dataIndex: "student_name",
    },
    {
      title: "Test Number",
      dataIndex: "mock_test_number",
    },
    {
      title: "Test Name",
      dataIndex: "test_name",
    },
    {
      title: "Total Questions",
      dataIndex: "total_questions",
    },
    {
      title: "Total Attempted",
      dataIndex: "total_attempted",
    },
    {
      title: "Correct Questions",
      dataIndex: "correct_questions",
    },
    {
      title: "Marks Obtained",
      dataIndex: "marks_obtained",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => viewResult(record)}>
            View Result
          </Button>
        </Space>
      ),
    },
  ];

  const [students, setStudents] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStudentId, setSelectedStudentId] = useState(null);

  useEffect(() => {
    getStudentsRequest();
    getResultsRequest();
  }, []);

  useEffect(() => {
    const data =
      getStudentResponse.data !== BLANK_VALUE ? getStudentResponse.data : [];
    setStudents(data);
  }, [getStudentResponse]);

  useEffect(() => {
    const data =
      getResultsResponse.data !== BLANK_VALUE ? getResultsResponse.data : [];
    const pagination =
      getResultsResponse.pagination !== BLANK_VALUE
        ? getResultsResponse.pagination
        : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [getResultsResponse]);

  const fetchResults = (page, student_id) => {
    let url = `/admin/student/get-all-results?pageNumber=${page}`;
    if (student_id) {
      url += `&student_id=${student_id}`;
    }
    getResultsRequest(null, API_METHODS.GET, url);
  };

  const onFilterChange = (values) => {
    setSelectedStudentId(values.student_id || null);
    setCurrentPage(1);
    fetchResults(1, values.student_id);
  };

  const onPaginationChange = (page) => {
    setCurrentPage(page.current);
    fetchResults(page.current, selectedStudentId);
  };

  const viewResult = (record) => {
    navigate("/portal/result/detail", {
      state: record,
    });
  };

  return (
    <Card title="Result">
      {students?.length > 0 && (
        <Form form={form} onFinish={onFilterChange}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="student_id" label="Student">
                <Select
                  placeholder="Select Student"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {students.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button type="primary" htmlType="submit">
                Filter
              </Button>
            </Col>
          </Row>
        </Form>
      )}
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={getResultsResponse.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />
    </Card>
  );
}

export default Result;
